import classNames from 'classnames';
import { User } from '@nx-frontend/shared/types';
import { getUserFirstLetters } from './utils/get-user-first-letters';

interface NotificationPanelMemberIconProps {
  member: User;
  additionalClasses?: string;
}

export const NotificationPanelMemberIcon = (props: NotificationPanelMemberIconProps) => {
  const { member, additionalClasses } = props;
  let icon = (
    <div
      className={classNames(
        'size-6 rounded-full bg-teal-500 flex items-center justify-center text-[10px] leading-3 font-semibold text-white',
        additionalClasses
      )}
    >
      {getUserFirstLetters(member)}
    </div>
  );
  if (member.avatar) {
    icon = (
      <img src={member.avatar} alt="avatar" className={classNames('size-6 rounded-full bg-white', additionalClasses)} />
    );
  }
  return icon;
};
